<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.72656 5V35H28.2266C28.2266 30.6853 31.3664 27.6562 35.7266 27.6562V17.5L26.2529 5H5.72656ZM8.09498 17.5V7.34375H24.6739L31.7792 17.5H8.09498Z"
      class="fill-current"
    />
  </svg>
</template>
